import React, { useContext } from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  withRouter,
  Redirect,
} from "react-router-dom";
import NotFoundPage from "../pages/NotFound";
import NewAccountPage from "../pages/NewAccount/index";
import LoginPage from "../pages/Login/index";
import FilterPage from "../pages/Filter/index";
import ForgotPasswordPage from "../pages/ForgotPassword/index";
import ResetPasswordPage from "../pages/ResetPassword/index";
import NewAccountSendPage from "../pages/NewAccountSend";
import TasksPage from "../pages/TasksPage";
import ActivedFlowsPage from "../pages/ActivedFlows";
import ModelFlowsPage from "../pages/ModelFlows";
import FinishedFlowsPage from "../pages/FinishedFlows";
import MembersPage from "../pages/Members";
import PaneProvider from "../pages/FlowPane/Provider";
import Workflow from "../pages/Workflow/index";
import AdvancedStats from "../pages/AdvancedStats";
import { AuthContext } from "../auth/AuthContext";
import NewFlowModal from "../components/general/AlertModals/NewFlowModal";
import { UserStats } from "../pages/UserStats";
import DashboardPage from "../pages/Dashboard/index";
import RDMPage from "../pages/RDM";
import RdmPanel from "../pages/rdmPanel";

const ProtectedRoute = ({ component: Component, allowedRanks, ...rest }) => {
  const localUserData = JSON.parse(localStorage.getItem("user"));
  const isAuthenticated = localUserData !== null;
  const isAllowed =
    isAuthenticated && allowedRanks.includes(localUserData?.rank);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          isAllowed ? (
            <Component {...props} />
          ) : (
            <Redirect to="/404" />
          )
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

const IndexRouter = () => {
  const { isLoading } = useContext(AuthContext);

  if (isLoading) {
    return null;
  }

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={TasksPage} />
        <Route path="/tasks" component={TasksPage} />
        <ProtectedRoute
          path="/ActivedFlows"
          component={ActivedFlowsPage}
          allowedRanks={["admin", "gerente", "colaborador"]}
        />
        <ProtectedRoute
          path="/finishedflows"
          component={FinishedFlowsPage}
          allowedRanks={["admin", "gerente"]}
        />
        <ProtectedRoute
          path="/modelflows"
          component={ModelFlowsPage}
          allowedRanks={["admin", "gerente"]}
        />
        <ProtectedRoute
          path="/dashboard"
          component={DashboardPage}
          allowedRanks={["admin", "gerente", "colaborador"]}
        />
        <Route path="/flowpane" component={PaneProvider} />
        <Route path="/members" component={MembersPage} />
        <Route path="/newaccount/:token" component={NewAccountPage} />
        <Route path="/newaccountsend" component={NewAccountSendPage} />
        <Route path="/workflow" component={Workflow} />
        <Route path="/userstats" component={UserStats} />
        <Route path="/advancedstats" component={AdvancedStats} />
        <Route path="/filter" component={FilterPage} />
        <Route path="/rdm" component={RDMPage} />
        <Route path="/rdmpanel/:id" component={RdmPanel} />
        <Route path="/forgotpassword" component={ForgotPasswordPage} />
        <Route path="/resetpassword/:token" component={ResetPasswordPage} />
        <Route exact path="/login" component={LoginPage} />
        <Route path="/404" component={NotFoundPage} />
        <Redirect to="/404" />
      </Switch>
      <NewFlowModal state="index" />
    </BrowserRouter>
  );
};
export default withRouter(IndexRouter);
